import { Component } from "@angular/core";
import { NavController, MenuController } from "@ionic/angular";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { AmplifyService } from "../services/amplify.service";
import { TwilioService } from "../services/twilio.service";

import { Router } from "@angular/router";
import { Platform } from "@ionic/angular";
import { Title } from "@angular/platform-browser";
//import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

//declare var FCMPlugin;
declare var mapsAutocomplete;

@Component({
  selector: "app-login",
  templateUrl: "./login.page.html",
  styleUrls: ["./login.page.scss"],
})
export class LoginPage {
  flags: any;

  constructor(
    public app: AppService,
    public twil: TwilioService,
    public amplify: AmplifyService,
    private http: HttpService,
    public platform: Platform,
    public menuCtrl: MenuController,
    private navCtrl: NavController,
    private router: Router,
    public title: Title
  ) {
    //LOAD BING WALLPAPER
    this.flags = {
      userData: { email: null, password: null, error: null },
      stepData: {
        email: null,
        password1: null,
        password2: null,
        confirmation: false,
        verificationcode: null,
        error: null,
      },
      step: 1,

      accounts: [],
      access: [],

      modalMode: null,
      modalItem: null,
      modalStep: 1,
      modalParams: null,
      pagePermission: 0,
      email: null,
      password: null,
      bingimg: null,
      diag: null,

      addressSearch: null,
      matches: { address: [], googleResult: [] },

      defaultCompany: { cid: null, name: null, epoch: null },
      defaultLocation: {
        company_id: null,
        epoch: null,
        name: null,
        phone: null,
        fax: null,
        email: null,
        suite: null,
        address: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        lat: null,
        lng: null,
        notes: null,
        settings:
          '{"logo":null,"accentColor":null,"operationHours":[],"operationBooking":[],"services":[],"taxes":[],"equipment":[],"printers":[],"payments":[],"destinations":[]}',
        timezone: null,
        profileApi: null,
        paymentApi: null,
      },
      defaultAccess: {
        cid: null,
        company_id: null,
        location_id: null,
        group_id: null,
        epoch: null,
        permissions: null,
      },

      defaultDevice: {
        cid: null,
        company_id: null,
        user_id: null,
        epoch: null,
        fcm_token: null,
        active: true,
        endpoint: null,
      },
    };
  }

  ionViewWillEnter() {
    //this.app.sysData.isLoggedIn = null;
    //localStorage['sysData'] = JSON.stringify(this.app.sysData);

    //this.menuCtrl.enable(false);
    //this.menuCtrl.swipeGesture(false);
    //this.bingWallpaper();
    this.bingWallpaper();
    // this.app.sysData.isLoggedIn = false;
    // this.app.sysData.cognitoUser = null;
    // this.app.sysData.cognitoTokens = null;
    //localStorage['sysData'] = JSON.stringify(this.app.sysData);
    this.resetDevice();
  }

  bingWallpaper() {
    this.http.get("https://www.bing.com/HPImageArchive.aspx?format=js&idx=0&n=1&mkt=en-US").then((data) => {
      this.flags.bingimg = "https://www.bing.com" + data["images"][0].url;
    });
  }

  //LOGIN FUNCTIONS
  login() {
    this.flags.userData.email = this.flags.userData.email.replace(/\s/g, "");

    this.amplify.authenticate(this.flags.userData.email, this.flags.userData.password).then(
      (res) => {
        if (res["attributes"]["sub"]) {
          console.log("login res", res);
          if (this.platform.is("ios")) {
            //FCMPlugin.requestPushPermissionIOS();
          }
          this.app.sysData.cognitoTokens = res["signInUserSession"];
          this.app.sysData.cognitoUser = res["attributes"];
          this.getUser();
        } else {
          this.flags.stepData.error = res["message"];
        }
      },
      (err) => {
        console.log("failed", err);
        this.flags.stepData.error = err.message;
      }
    );
  }

  //LOGIN SUCCESS PERMISSIONS
  getPermissions() {
    console.log("Get permissions");

    this.flags.step = 1.1;
    this.flags.stepData.invite = null;
    //this.http.apiGet('user_access/location_id/' + this.flags.profileFocusData.location_id + '?join=user_accounts,user_id,id', null).then(data => {
    this.http
      .apiGet("user_access/cid/" + this.app.sysData.cognitoUser.sub + "?join=company,company_id,id", null)
      .then((data) => {
        console.log("JOIN TEST", data.data);

        this.app.sysData.userAccess = data.data;
        this.flags.access = data.data;
      })
      .catch((err) => {
        console.log("failed", err);
        this.app.alert(err.message);
      });
  }

  selectPermission(item) {
    this.http
      .apiGet("company/id/" + item.company_id, null)
      .then((data) => {
        this.app.sysData.isLoggedIn = true;
        this.app.sysData.company_id = item.company_id;
        this.app.sysData.company = item;
        this.app.sysData.userId = this.flags.editUser.id;
        this.app.sysData.agent_name = this.flags.editUser.first_name + " " + this.flags.editUser.last_name;

        //this.app.sysData.permission
        this.app.sysData.accessId = item.id;
        this.app.sysData.access = item.permissions;
        //this.app.alert(this.app.sysData.access);

        //this.app.locData = data.data[0];
        //this.app.locData.settings = JSON.parse(this.app.locData.settings); //parse settings

        // if (!this.app.sysData.pwa) { //loda previous sysdata
        //     localStorage['sysData'] = JSON.stringify(this.app.sysData);
        //     localStorage['locData'] = JSON.stringify(data.data[0]);
        // }

        localStorage["sysData"] = JSON.stringify(this.app.sysData);
        console.log("sysData", this.app.sysData);

        //this.twil.getTwilioPhoneToken(); //get phone token

        this.updateDeviceToken();
        this.app.subscribe(); //subscribe to feed events

        this.navCtrl.navigateRoot("/home");
      })
      .catch((err) => {
        console.log("failed", err);
        this.app.alert(err.message);
      });
  }

  resetDevice() {
    var obj = {
      fcm_token: this.app.sysData.fcmToken,
    };

    if (obj.fcm_token) {
      this.http
        .apiPost("delFCM", { data: obj }, null)
        .then((data) => {
          console.log("device saved", data);
          this.app.toast("Device Fully Reset", "success");
          this.removeTokens();
        })
        .catch((err) => {
          console.log("failed", err);
          this.app.toast("Device Partially Reset", "tertiary");
          this.removeTokens();
        });
    } else {
      this.app.toast("Device Reset", "success");
      this.removeTokens();
    }
  }

  removeTokens() {
    this.amplify.signOut();
    localStorage.clear();
    this.app.sysData.isLoggedIn = false;
    this.app.twilioToken = null;
  }

  updateDeviceToken() {
    var obj = JSON.parse(JSON.stringify(this.flags.defaultDevice));
    obj.cid = this.app.sysData.cognitoUser.sub;
    obj.company_id = this.app.sysData.company_id;
    obj.user_id = this.app.sysData.userId;
    obj.fcm_token = this.app.sysData.fcmToken;
    obj.epoch = Date.now();
    obj.active = 1;

    if (obj.fcm_token) {
      this.http.apiPost("addFCM", { data: obj }, null).then((data) => {
        console.log("device saved", data);
      });
    }
  }

  setPermission() {
    if (this.flags.stepData.invite) {
      this.http.apiGet("user_access/token/" + this.flags.stepData.invite, null).then((data) => {
        if (data.data[0] && !data.data[0].cid) {
          console.log(data);

          //update permission
          var temp = { cid: this.app.sysData.cognitoUser.sub, token: null };
          this.http
            .apiPut("user_access/id/" + data.data[0].id, { data: temp }, null)
            .then((data) => {
              this.app.toast("Invite code accepted", "success");
              this.getPermissions();
            })
            .catch((err) => {
              this.app.toast("Could update account, Please try again later or contact us", "danger");
            });
          //end permission update
        } else {
          this.app.alert("Invite code was invalid");
        }
      });
    } else {
      this.app.alert("Please enter your invite code");
    }
  }
  //END LOGIN SUCCESS PERMISSIONS

  //USER DETAILS
  getUser() {
    console.log("get user", this.app.sysData.cognitoUser);
    this.http
      .apiGet("user_accounts/cid/" + this.app.sysData.cognitoUser.sub, null)
      .then((data) => {
        console.log("got data", data);
        this.flags.editUser = data.data[0];
        if (!data["data"][0]["status"]) {
          //if user has missing profile info
          this.flags.step = 4;
          //this.getCompany();
        } else {
          //if no missing
          //this.app.sysData.company_id = data.data[0].company_id;
          this.app.sysData.permission = data["data"][0]["permission"];
          //this.app.alert(this.app.sysData.access);
          this.getPermissions();
        }
      })
      .catch((err) => {
        console.log("failed", err);
        this.app.alert(err.message);
      });
  }

  saveUser() {
    var temp = JSON.parse(JSON.stringify(this.flags.editUser));
    temp.status = 1;
    temp.epoch = Date.now();

    this.http
      .apiPut("user_accounts/id/" + this.flags.editUser.id, { data: temp }, null)
      .then((data) => {
        this.app.toast("Modified User Saved", "success");
        this.getPermissions();
      })
      .catch((err) => {
        this.app.toast("Could update account, Please try again later or contact us", "danger");
      });
  }

  //END USER DETAILS

  //COMPANY UTILITIES
  getCompany() {
    console.log("get company");
    this.http
      .apiGet("company/cid/" + this.app.sysData.cognitoUser.sub, null)
      .then((data) => {
        console.log("got data", data);
        if (!data["data"][0]) {
          //if no result
          console.log("no company set default");
          this.flags.editCompany = JSON.parse(JSON.stringify(this.flags.defaultCompany));
          this.flags.editCompany.epoch = Date.now();
          this.flags.editCompany.cid = this.app.sysData.cognitoUser.sub;
        } else {
          this.flags.editCompany = data["data"][0];
          this.flags.editUser.company_id = data["data"][0].id;
          console.log("company", data["data"]);
          //this.getLocation();
        }
      })
      .catch((err) => {
        console.log("failed", err);
        this.app.alert(err.message);
      });
  }
  saveCompany() {
    this.http
      .apiPost("company", { data: this.flags.editCompany }, null)
      .then((data) => {
        this.app.toast("Company Saved", "success");
        this.getCompany();
      })
      .catch((err) => {
        //this.navCtrl.navigateRoot('/account');
        this.app.toast("Could update account, Please try again later or contact us", "danger");
      });
  }
  //END COMPANY DETAILS

  //LOCATION UTILITIES
  // getLocation() {
  //     console.log('get company');
  //     this.http.apiGet('company_locations/company_id/' + this.flags.editCompany.id, null).then(data => {
  //         console.log('got data', data);
  //         if (!data['data'][0]) {
  //             console.log('no location set default');
  //             this.flags.editLocation = JSON.parse(JSON.stringify(this.flags.defaultLocation));
  //             this.flags.editLocation.epoch = Date.now();
  //             this.flags.editLocation.company_id = this.flags.editCompany.id;
  //         } else {
  //             this.flags.editLocation = data['data'][0];
  //             console.log('company', data['data']);
  //             this.getAccess();
  //         }
  //     }).catch(err => {
  //         console.log('failed', err);
  //         this.app.alert(err.message);
  //     });
  // }
  // saveLocation() {
  //     this.http.apiPost('company_locations', { data: this.flags.editLocation }, null).then(data => {
  //         this.app.toast('Company Saved', 'success');
  //         this.getLocation();
  //     }).catch(err => {
  //         //this.navCtrl.navigateRoot('/account');
  //         this.app.toast('Could update account, Please try again later or contact us', 'danger');
  //     });
  // }
  //END COMPANY DETAILS

  //END LOGIN FUNCTIONS

  resetStep() {
    this.flags.stepData = {
      email: null,
      password1: null,
      password2: null,
      confirmation: false,
      verificationcode: null,
      error: null,
    };
    this.flags.step = 1;
    this.amplify.signOut();
  }

  step(m) {
    this.flags.stepData = {
      email: null,
      password1: null,
      password2: null,
      confirmation: false,
      verificationcode: null,
      error: null,
    };
    this.flags.step = m;
  }

  //PASSWORD FUNCTIONS
  register() {
    console.log("register run");
    this.flags.stepData.error = null;
    if (this.flags.stepData.password1 == this.flags.stepData.password2) {
      console.log("passwords match");
      this.amplify.registerUser(this.flags.stepData.email, this.flags.stepData.password1).then(
        (res) => {
          if (res["codeDeliveryDetails"]["Destination"]) {
            //this.app.alert(JSON.stringify(res));
            console.log(res);
            this.app.alert("Confirmation Email sent to: " + res["user"]["username"]);
            //this.promptVerificationCode();
            this.resetStep();
          }
        },
        (err) => {
          //this.app.toast('failed ' + JSON.stringify(err), 'danger');
          this.flags.stepData.error = err.message;
          console.log(err);
        }
      );
    } else {
      console.log("passwords do not match");
      this.flags.stepData.error = "Your passwords do not match";
    }
  }

  resendVerificationCode() {
    this.flags.stepData.error = null;
    this.amplify.resendConfirmationCode(this.flags.stepData.email).then(
      (res) => {
        this.app.alert("Confirmation resent");
      },
      (err) => {
        console.log(err);
        this.flags.stepData.error = err.message;
      }
    );
  }

  forgotPassword() {
    this.amplify.forgotPassword(this.flags.stepData.email).then(
      (res) => {
        console.log(res);
        //this.flags.stepData.message = 'Reset Code sent to ' + JSON.stringify(res['CodeDeliveryDetails']['Destination']);
        this.app.toast("Reset Code sent to " + JSON.stringify(res["CodeDeliveryDetails"]["Destination"]), "success");
        this.flags.step = 5.1;
        this.flags.stepData.error = null;
      },
      (err) => {
        console.log("failed", err);
        this.flags.stepData.error = err.message;
      }
    );
  }

  forgotPasswordConfirmation() {
    this.flags.stepData.error = null;
    if (this.flags.stepData.password1 == this.flags.stepData.password2) {
      this.amplify
        .resetPassword(this.flags.stepData.email, this.flags.stepData.verificationcode, this.flags.stepData.password1)
        .then(
          (res) => {
            console.log(res);
            this.app.alert("Password Reset Please Login");
            this.resetStep();
          },
          (err) => {
            console.log("failed", err);
            this.flags.stepData.error = err.message;
          }
        );
    } else {
      this.flags.stepData.error = "Your passwords do not match";
    }
  }

  promptVerificationCode() {
    this.flags.step = 3;
    this.flags.stepData.verificationcode = null;
  }
  //END PASSWORD FUNCTIONS

  completeFirstRun() {
    this.app.sysData.firstRun = false;
    localStorage["settings"] = JSON.stringify(this.app.sysData);
  }

  //ADDRESS SEARCH
  async searchLocation() {
    mapsAutocomplete(this.flags.addressSearch).then((data) => {
      console.log("Google results" + data);
      this.flags.matches.googleResult = JSON.parse(JSON.stringify(data));
    });
  }

  selectLocation(m, i) {
    console.log("selected Location" + JSON.stringify(this.flags.matches.googleResult[i]));
    var address = this.flags.matches.googleResult[i].structured_formatting.main_text;
    var url =
      "https://maps.googleapis.com/maps/api/place/details/json?place_id=" +
      this.flags.matches.googleResult[i].place_id +
      "&fields=geometry,address_component&key=AIzaSyCInHxC__ddBstcY_r0G-NmxhEJluUDpXQ";

    this.http.get(url).then((data) => {
      console.log("Selection results ", data);
      console.log(JSON.stringify(data["result"].geometry));

      if (m == "l") {
        //location address
        this.flags.editLocation.address = address;
        var obj = data["result"].address_components;
        for (var i = 0; i < obj.length; i++) {
          for (var j = 0; j < obj[i].types.length; j++) {
            if (obj[i].types[j] == "locality") {
              this.flags.editLocation.city = obj[i].long_name;
            }
            if (obj[i].types[j] == "administrative_area_level_1") {
              this.flags.editLocation.state = obj[i].short_name;
            }
            if (obj[i].types[j] == "country") {
              this.flags.editLocation.country = obj[i].long_name;
            }
            if (obj[i].types[j] == "postal_code") {
              this.flags.editLocation.zip = obj[i].short_name;
            }
          }
        }
        this.flags.editLocation.lat = data["result"].geometry.location.lat;
        this.flags.editLocation.lng = data["result"].geometry.location.lng;
      }

      if (m == "u") {
        //user address
        this.flags.editUser.address = address;
        var obj = data["result"].address_components;
        for (var i = 0; i < obj.length; i++) {
          for (var j = 0; j < obj[i].types.length; j++) {
            if (obj[i].types[j] == "locality") {
              this.flags.editUser.city = obj[i].long_name;
            }
            if (obj[i].types[j] == "administrative_area_level_1") {
              this.flags.editUser.state = obj[i].short_name;
            }
            if (obj[i].types[j] == "country") {
              this.flags.editUser.country = obj[i].long_name;
            }
            if (obj[i].types[j] == "postal_code") {
              this.flags.editUser.zip = obj[i].short_name;
            }
          }
        }
        this.flags.editUser.lat = data["result"].geometry.location.lat;
        this.flags.editUser.lng = data["result"].geometry.location.lng;
      }

      this.flags.matches.googleResult = [];
      this.flags.addressSearch = null;
    });
  }

  //END ADDRESS SEARCH

  ionViewWillLeave() {
    //this.menuCtrl.enable(true);
    //this.menuCtrl.swipeGesture(true);
  }

  ngOnInit() {
    this.title.setTitle("Arii DGX - Login");
  }
}
